export default "__VITE_ASSET__BZgMMu_a__"